// extracted by mini-css-extract-plugin
module.exports = {"starButton":"Star_starButton__UeMsd","selected":"Star_selected__M87yb"};